/**
 * @description IT设备监控 ITDeviceMonitor
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const ITDeviceMonitorBiz = new Logic()

ITDeviceMonitorBiz.getKpi = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDeviceMonitor.getKpi,
    data: data
  })
}

ITDeviceMonitorBiz.getChartData = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDeviceMonitor.getChartData,
    data: data
  })
}

ITDeviceMonitorBiz.getChartDataNoModel = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDeviceMonitor.getChartData,
    data: data,
  }, false, true)
}

ITDeviceMonitorBiz.getAllChartData = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ITDeviceMonitor.getChartData,
    data: data,
    allData: true
  }, false, true)
}

export default ITDeviceMonitorBiz
